export const defaultFlightArrayItem = {
    s_flight_number: '',
    s_logo: '',
    uniqueFlightAwbs: [],
    notifiedSum: 0,
    notifiedPercent: ''
}